/**
 * Get the values of style properties on an element
 * @param element The element to get the style value from
 * @param style The style property to get the value of
 * @returns The value of the style property
 *
 * @example
 * ```ts
 * const element = document.createElement('div');
 * element.style.width = '100px';
 * element.style.height = '200px';
 * getElementStyleValues(element, ['width', 'height']); // ['100px', '200px']
 * ```
 */
export const getElementStyleValues = (
	element: Element,
	styles: string[],
	pseudoElt?: string | null,
) => {
	const computedStyles = getComputedStyle(element, pseudoElt);
	return styles.map((style) => computedStyles.getPropertyValue(style));
};
